export default __webpack_public_path__ + "static/media/Rolling.b81d6725.svg";